import { everest } from '~/services/serviceInstances';

export const unpublishWorkflow = async ({ id }: { id: string }) => {
  return await everest.patch(`/workflows/${id}/unpublish`);
};
